function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-svg-class": "RoomButton-stroke",
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF",
  transform: "translate(-4)"
}, /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 7,
  height: 109,
  x: 78.5,
  y: 0.5,
  fill: "#2B415E",
  rx: 3.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 7,
  height: 109,
  x: 94.5,
  y: 0.5,
  fill: "#2B415E",
  rx: 3.5
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 7,
  height: 109,
  x: 109.5,
  y: 0.5,
  fill: "#2B415E",
  rx: 3.5
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  fill: "#2B415E",
  d: "M18.358 54.234L4.694 56.5l6.626 12.163"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.91 54.5c-11.52-7.86-20.784-6.694-40.673 1.192-18.672 7.404-26.578 8.42-36.473 1.733"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  fill: "#2B415E",
  d: "M18.358 80.234L4.694 82.5l6.626 12.163"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.91 80.5c-11.52-7.86-20.784-6.694-40.673 1.192-18.672 7.404-26.578 8.42-36.473 1.733"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  fill: "#2B415E",
  d: "M18.358 28.234L4.694 30.5l6.626 12.163"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.91 28.5c-11.52-7.86-20.784-6.694-40.673 1.192-18.672 7.404-26.578 8.42-36.473 1.733"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  fill: "#2B415E",
  d: "M38.5 36.006c-1.997 3.527-3 5.883-3 6.972a3 3 0 106 0c0-1.089-1.003-3.445-3-6.972zm30 20c-1.997 3.527-3 5.883-3 6.972a3 3 0 106 0c0-1.089-1.003-3.445-3-6.972zm-14 27c-1.997 3.527-3 5.883-3 6.972a3 3 0 106 0c0-1.089-1.003-3.445-3-6.972z"
}));

function SvgRoomHumidifier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 113,
    height: 110,
    viewBox: "0 0 113 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomHumidifier);
export default __webpack_public_path__ + "static/media/RoomHumidifier.b268ed80.svg";
export { ForwardRef as ReactComponent };